import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createSegmento, editSegmento, getSegmentos } from "../../Services/segmento_service";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";

const initialState = {
    segmentos: [],
    segmento: {
        nombre: '',
        descripcion: '',
        estado: 1,
    },
}

export const segmentoSlice = createSlice({
    name: 'segmento',
    initialState,
    reducers: {
        setSegmentos: (state, action) => {
            state.segmentos = action.payload;
        },
        setSegmento: (state, action) => {
            state.segmento = !action.payload ? initialState.segmento : action.payload;
        },
    }
});

export const fetchSegmentos = createAsyncThunk(
    'segmentos/fetchSegmentos',
    async (_, { dispatch }) => {
        const segmentosRes = await getSegmentos();
        dispatch(setSegmentos(segmentosRes));
    }
);

export const addSegmento = createAsyncThunk(
    'segmentos/create',
    async (data, {dispatch}) => {
        dispatch(setLoading(true))
        const segmentoRes = await createSegmento(data);
        dispatch(setResponse(segmentoRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchSegmentos());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const EditSegmento = createAsyncThunk(
    'segmentos/update',
    async (data, {dispatch}) => {
        dispatch(setLoading(true))
        const segmentoRes = await editSegmento(data);
        dispatch(setResponse(segmentoRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchSegmentos());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setSegmentos, setSegmento } = segmentoSlice.actions;
export default segmentoSlice.reducer;